import type { SVGProps } from "react";
import type { IconSize } from "./IconSize";
export function getIconSize(size: IconSize = "small"): Pick<SVGProps<unknown>, "height" | "width"> {
    switch (size) {
        case "small":
            return { width: "1rem", height: "1rem" };
        case "medium":
            return { width: "1.5rem", height: "1.5rem" };
        case "large":
            return { width: "2rem", height: "2rem" };
    }
}
